"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartUtils = void 0;
const index_1 = require("../constants/index");
class CartUtils {
    static calculateDiscountedPrice(price, discountAmount) {
        const discountedPrice = CartUtils.normaliseDiscountAmount(discountAmount);
        return Number(price) - discountedPrice;
    }
    static cartIsExpired(commonError) {
        var _a, _b;
        return ((_a = commonError.code) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === index_1.NotFoundError.Code.toLowerCase() &&
            ((_b = commonError.message) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === index_1.NotFoundError.Message.toLowerCase();
    }
    static getPromotionDiscount(discounts, isCouponDiscount = true) {
        return (isCouponDiscount) ? discounts.find(discount => discount.isCouponDiscount === isCouponDiscount) : discounts === null || discounts === void 0 ? void 0 : discounts[0];
    }
    static normaliseDiscountAmount(discountAmount) {
        return (discountAmount) ? parseFloat(discountAmount.replace('-$', '')) : 0;
    }
}
exports.CartUtils = CartUtils;
//# sourceMappingURL=cart.utils.js.map